import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import AddUserBlackListPopUp from 'components/UserBlackList/AddUserBlackListPopUp';
import RemoveUserBlackListPopUp from 'components/UserBlackList/RemoveUserBlackListPopUp';

import { dataRequest as refreshUserById } from 'mt-react-common/common/reducers/objectCollection/reducer';

class UserBlackListControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopUpAddToBlackListExecutor: false,
      showPopUpRemoveFromBlackListExecutor: false,
      showPopUpAddToBlackListCustomer: false,
      showPopUpRemoveFromBlackListCustomer: false
    };
  }

  handleShowPopUpAddToBlackListExecutor = bool => {
    this.setState({
      showPopUpAddToBlackListExecutor: bool
    });
  };

  handleShowPopUpRemoveFromBlackListExecutor = bool => {
    this.setState({
      showPopUpRemoveFromBlackListExecutor: bool
    });
  };

  handleShowPopUpAddToBlackListCustomer = bool => {
    this.setState({
      showPopUpAddToBlackListCustomer: bool
    });
  };

  handleShowPopUpRemoveFromBlackListCustomer = bool => {
    this.setState({
      showPopUpRemoveFromBlackListCustomer: bool
    });
  };

  render() {
    return (
      <div className="panel panel-default border-t">
        <AddUserBlackListPopUp
          categoryId={2}
          blockedUserId={this.props.userInfo.id}
          in={this.state.showPopUpAddToBlackListExecutor}
          handleClose={() => this.handleShowPopUpAddToBlackListExecutor(false)}
          handleSuccess={() =>
            this.props.refreshUserById(this.props.userInfo.id)
          }
        />
        <RemoveUserBlackListPopUp
          categoryId={2}
          blockedUserId={this.props.userInfo.id}
          in={this.state.showPopUpRemoveFromBlackListExecutor}
          handleClose={() =>
            this.handleShowPopUpRemoveFromBlackListExecutor(false)
          }
          handleSuccessQuery={() =>
            this.props.refreshUserById(this.props.userInfo.id)
          }
        />
        <AddUserBlackListPopUp
          categoryId={1}
          blockedUserId={this.props.userInfo.id}
          in={this.state.showPopUpAddToBlackListCustomer}
          handleClose={() => this.handleShowPopUpAddToBlackListCustomer(false)}
          handleSuccess={() =>
            this.props.refreshUserById(this.props.userInfo.id)
          }
        />
        <RemoveUserBlackListPopUp
          categoryId={1}
          blockedUserId={this.props.userInfo.id}
          in={this.state.showPopUpRemoveFromBlackListCustomer}
          handleClose={() =>
            this.handleShowPopUpRemoveFromBlackListCustomer(false)
          }
          handleSuccessQuery={() =>
            this.props.refreshUserById(this.props.userInfo.id)
          }
        />
        <div className="panel-body">
          <div className="panel-title panel-title_xs text-center">
            {t('Черный список исполнителей')}{' '}
            {this.props.userInfo.outOfMyBlackListExecutor ? (
              <i
                className="fa fa-check-square-o fa-fw"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Пользователь включен в черный список исполнителей')}
              />
            ) : null}
          </div>
          {this.props.userInfo.outOfMyBlackListExecutor ? (
            <div className="form-group">
              <button
                className="btn btn-default btn-block btn-danger"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Удалить пользователя из черного списка исполнителей')}
                onClick={() =>
                  this.handleShowPopUpRemoveFromBlackListExecutor(true)
                }
              >
                <i className="fa fa-user-times fa-fw" />{' '}
                {t('Удалить из списка')}
              </button>
            </div>
          ) : (
            <div className="form-group">
              <button
                className="btn btn-default btn-block"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Добавить пользователя в черный список исполнителей')}
                onClick={() => this.handleShowPopUpAddToBlackListExecutor(true)}
              >
                <i className="fa fa-user-plus fa-fw" /> {t('Добавить в список')}
              </button>
            </div>
          )}
          <div className="panel-title panel-title_xs text-center">
            {t('Черный список заказчиков')}{' '}
            {this.props.userInfo.outOfMyBlackListCustomer ? (
              <i
                className="fa fa-check-square-o fa-fw"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Пользователь включен в черный список заказчиков')}
              />
            ) : null}
          </div>
          {this.props.userInfo.outOfMyBlackListCustomer ? (
            <div className="form-group">
              <button
                className="btn btn-default btn-block btn-danger"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Удалить пользователя из черного списка заказчиков')}
                onClick={() =>
                  this.handleShowPopUpRemoveFromBlackListCustomer(true)
                }
              >
                <i className="fa fa-user-times fa-fw" />{' '}
                {t('Удалить из списка')}
              </button>
            </div>
          ) : (
            <div className="form-group">
              <button
                className="btn btn-default btn-block"
                data-toggle="tooltip"
                data-placement="top"
                data-container="body"
                title={t('Добавить пользователя в черный список заказчиков')}
                onClick={() => this.handleShowPopUpAddToBlackListCustomer(true)}
              >
                <i className="fa fa-user-plus fa-fw" /> {t('Добавить в список')}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

UserBlackListControl.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    outOfMyBlackListCustomer: PropTypes.shape({}),
    outOfMyBlackListExecutor: PropTypes.shape({})
  }).isRequired,

  // CONNECT DISPATCH
  refreshUserById: PropTypes.func.isRequired
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  refreshUserById: blockedUserId =>
    dispatch(
      refreshUserById(
        'usersModule.collections.userCollection',
        blockedUserId,
        false
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBlackListControl);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/RightSidebarUserProfile/UserBlackListControl.js